import DSBridge from "dsbridge";
const errorObject = {
  result: false,
  message: "您的设备版本较低，外教视频功能已暂停，建议使用语音上课～",
};
export const videoState = {
  STATE_DOWNLOAD_PROGRESS: "下载中",
  STATE_DOWNLOAD_COMPLETED: "下载完成",
  STATE_DOWNLOAD_ERROR: "下载错误",
  STATE_UNZIP_PROGRESS: "解压中",
  STATE_UNZIP_COMPLETED: "解压完成",
  STATE_UNZIP_ERROR: "解压错误",
  STATE_MODEL_NIL: "当前教师-无可用模型",
};
export const checkDevice = () => {
  try {
    const deviceResult = JSON.parse(DSBridge.call("duix.checkDevice"));
    if (Boolean(deviceResult?.data?.status) !== true) {
      return {
        result: false,
        message: deviceResult?.data?.info,
      };
    } else {
      return true;
    }
  } catch (e) {
    console.log(e);
    return errorObject;
  }
};

export const getInfoList = (teacher = {}) => {
  try {
    const infoResult = JSON.parse(
      DSBridge.call("duix.getInfo", { ...teacher })
    );
    if (
      Boolean(infoResult?.result) === true &&
      Array.isArray(infoResult.data)
    ) {
      return infoResult.data;
    } else {
      return errorObject;
    }
  } catch (e) {
    console.log(e);
    return errorObject;
  }
};
